export const PERMISSIONS = {
  // Users & Roles
  USER_VIEW:           'user:view',
  USER_CREATE:         'user:create',
  USER_UPDATE:         'user:update',
  USER_DELETE:         'user:delete',
  USER_APPROVE:        'user:approve',
  USER_REJECT:         'user:reject',
  USER_UNLOCK:         'user:unlock',
  USER_RESET_PASSWORD: 'user:rese_password',

  ROLE_VIEW:   'role:view',
  ROLE_CREATE: 'role:create',
  ROLE_UPDATE: 'role:update',
  ROLE_DELETE: 'role:delete',

  // Campaigns
  CAMPAIGN_VIEW:    'campaign:view',
  CAMPAIGN_CREATE:  'campaign:create',
  CAMPAIGN_UPDATE:  'campaign:update',
  CAMPAIGN_APPROVE: 'campaign:approve',
  CAMPAIGN_REJECT:  'campaign:reject',
  CAMPAIGN_CANCEL:  'campaign:cancel',

  // Campaign Winners
  CAMPAIGN_WINNER_VIEW:     'campaign_winner:view',
  CAMPAIGN_WINNER_ANNOUNCE: 'campaign_winner:announce',
  CAMPAIGN_WINNER_EXECUTE:  'campaign_winner:execute',
  CAMPAIGN_WINNER_TRX_VIEW: 'campaign_winner_trx:view',

  // CSV Templates
  CSV_TEMPLATE_VIEW:   'csv_template:view',
  CSV_TEMPLATE_CREATE: 'csv_template:create',
  CSV_TEMPLATE_UPDATE: 'csv_template:update',
  CSV_TEMPLATE_DELETE: 'csv_template:delete',

  // Transactions
  TRANSACTION_VIEW:   'transaction:view',
  TRANSACTION_UPDATE: 'transaction:update',

  // Upload
  TRX_UPLOAD_VIEW: 'trx_upload:view',
  TRX_UPLOAD_SAVE: 'trx_upload:save',

  // User Config (Notification Config)
  USER_CONFIG_VIEW:   'user_config:view',
  USER_CONFIG_CREATE: 'user_config:create',
  USER_CONFIG_UPDATE: 'user_config:update',
  USER_CONFIG_DELETE: 'user_config:delete',

  // Password Policy
  PASSWORD_POLICY_VIEW:   'password_policy:view',
  PASSWORD_POLICY_DELETE: 'password_policy:delete',
  PASSWORD_POLICY_UPSERT: 'password_policy:upsert',

  // Audit & Activity
  AUDIT_REPORT_VIEW:     'audit_report:view',
  AUDIT_REPORT_DOWNLOAD: 'audit_report:download',
  ACTIVITY_LOG_VIEW:     'activity_log:view',

  SCREEN_MAKER_VIEW: 'screen_maker:view',

  // AD Config
  AD_CONFIG_VIEW:   'ad_config:view',
  AD_CONFIG_UPSERT: 'ad_config:upsert',

  // Notification Config
  NOTIFICATION_CONFIG_VIEW:   'notification_config:view',
  NOTIFICATION_CONFIG_UPSERT: 'notification_config:upsert',
  NOTIFICATION_CONFIG_DELETE: 'notification_config:delete',

  // Blacklist
  BLACKLIST_VIEW:   'blacklist:view',
  BLACKLIST_DELETE: 'blacklist:delete',
  BLACKLIST_CREATE : 'blacklist:create',

  // Institution
  INSTITUTION_VIEW:   'institution:view',
  INSTITUTION_CREATE: 'institution:create',
  INSTITUTION_UPDATE: 'institution:update',
  INSTITUTION_DELETE: 'institution:delete',
};